import { Route, Switch, Redirect } from 'react-router-dom'

import { hasScopesPermission } from '@tribeplatform/gql-client/lib'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'

import { AdminMenu } from './AdminMenu'
import { Apps } from './Apps'
import { AppPage } from './Apps/AppPage'
import { AuditLogs } from './AuditLogs'
import { Billing } from './Billing'
import { GettingStarted } from './Dashboard/GettingStarted'
import { WhatsNew } from './Dashboard/WhatsNew'
import { EditorPreview } from './Editor/EditorPreview'
import { EmailLogs } from './EmailLogs'
import { MemberFields } from './MemberFields'
import { Members } from './Members'
import { Admins } from './Members/Administrators'
import { Invitations } from './Members/Invitations'
import { ModerationSettings } from './ModerationSettings'
import { Posts } from './Posts'
import { Security } from './Security'
import { Authentication } from './Settings/Authentication'
import { Settings } from './Settings/CommunitySettings'
import { Domain } from './Settings/Domain'
import { SeoSettings } from './Settings/SeoSettings'
import { Spaces } from './Spaces'

export const Admin = () => {
  const { data: network } = useNetwork()
  const [canUpdateNetwork] = hasScopesPermission(network, ['updateNetwork'])

  if (!canUpdateNetwork) {
    return <Redirect to="/" />
  }
  return (
    <AdminMenu>
      <Switch>
        <Route path="/manage/people/fields" exact>
          <MemberFields />
        </Route>
        <div className="sm:px-5 py-5">
          <Route path="/manage/dashboard/whats-new" exact>
            <WhatsNew />
          </Route>
          <Route path="/manage/reports/audit-logs" exact>
            <AuditLogs />
          </Route>
          <Route path="/manage/reports/email-logs" exact>
            <EmailLogs />
          </Route>
          <Route path="/manage/people/members" exact>
            <Members />
          </Route>
          <Route path="/manage/people/invitations" exact>
            <Invitations />
          </Route>
          <Route path="/manage/people/admin" exact>
            <Admins />
          </Route>
          <Route path="/manage/content/posts" exact>
            <Posts />
          </Route>
          <Route path="/manage/content/spaces" exact>
            <Spaces />
          </Route>
          <Route path="/manage/editor/colors" exact>
            <EditorPreview />
          </Route>
          <Route path="/manage/editor/typography" exact>
            <EditorPreview />
          </Route>
          <Route path="/manage/dashboard/getting-started" exact>
            <GettingStarted />
          </Route>
          <Route path="/manage/settings/network" exact>
            <Settings />
          </Route>
          <Route path="/manage/settings/authentication" exact>
            <Authentication />
          </Route>
          <Route path="/manage/settings/domain" exact>
            <Domain />
          </Route>
          <Route path="/manage/settings/seo" exact>
            <SeoSettings />
          </Route>
          <Route path="/manage/settings/security" exact>
            <Security />
          </Route>
          <Route path="/manage/apps" exact>
            <Apps />
          </Route>
          <Route path="/manage/apps/:appSlug">
            <AppPage />
          </Route>
          <Route path="/manage/settings/moderation" exact>
            <ModerationSettings />
          </Route>
          <Route path="/manage/settings/billing">
            <Billing />
          </Route>
        </div>
      </Switch>
    </AdminMenu>
  )
}
